export default "__VITE_ASSET__6aeb2554__"